// Демо-форма подсказок по адресам.

import helper from "../domain/address";
import utils from "../utils";
import createComponent from "../vue";
import objectLink from "./object-link";
import SuggestionsService from "./service";
import Analytics from "../marketing/analytics";
import demoFormPopup from "../popups/components/demo-form-popup/index";

const $ = window.jQuery;

const STATE = {
    address: null,
    copied: false,
    delivery: null,
    enableForeign: false,
    englishLanguage: false,
    municipalDivision: false,
    feedback_value: "",
    value: "",
    type: "ADDRESS",
    usageTimes: 0,
};

const HINT = {
    ru: "Выберите вариант или продолжите ввод",
    en: "Choose a suggestion or continue typing",
};

const deliveryService = new SuggestionsService("delivery");

const properies = {
    areaWithSubarea() {
        return helper.areaWithSubarea(this.address);
    },

    cadNum() {
        return helper.cadNum(this.address);
    },

    capitalMarker() {
        return helper.capitalMarker(this.address);
    },

    centralArea() {
        return helper.centralArea(this.address);
    },

    cityAdditional() {
        return helper.cityAdditional(this.address);
    },

    cityWithSettlement() {
        return helper.cityWithSettlement(this.address);
    },

    copyLinkEnabled() {
        if (helper.isForeign(this.address)) {
            return Boolean(this.address.fias_id || this.address.geoname_id);
        }
        return this.address.fias_id && this.address.fias_actuality_state === "0";
    },

    fiasCodes() {
        return helper.fiasCodes(this.address);
    },

    fiasLevel() {
        return helper.fiasLevel(this.address);
    },

    flatPrice() {
        return helper.flatPrice(this.address);
    },

    historyValues() {
        return `бывш. ${utils.join(this.address.history_values, ", ")}`;
    },

    houseWithBlock() {
        return helper.houseWithBlock(this.address);
    },

    geoLink() {
        return helper.geoLink(this.address);
    },

    geoLinkLabel() {
        return helper.geoLinkLabel(this.address);
    },

    geoLinkDescription() {
        return helper.geoLinkDescription(this.address);
    },

    good() {
        return helper.isGood(this.address);
    },

    isForeign() {
        return helper.isForeign(this.address);
    },

    isValidFiasLevel() {
        return helper.isValidFiasLevel(this.address);
    },

    isoCodes() {
        return helper.isoCodes(this.address);
    },

    metro() {
        return helper.metro(this.address);
    },

    regionWithArea() {
        return helper.regionWithArea(this.address);
    },

    suggestions() {
        return $(this.$refs.input)
            .suggestions();
    },

    validationMessage() {
        return helper.validationMessage(this.address);
    },
};

const methods = {
    hasHistoryValues(level) {
        return helper.hasHistoryValues(this.address, level);
    },

    getDelivery(event) {
        const cityKladrId =
            this.address.settlement_kladr_id ||
            this.address.city_kladr_id ||
            this.address.region_kladr_id;
        this.delivery = {
            boxberry_id: "—",
            cdek_id: "—",
            dpd_id: "—",
        };
        deliveryService.findById(cityKladrId)
            .done(suggestion => {
                this.delivery.boxberry_id = suggestion.data.boxberry_id ||
                    this.delivery.boxberry_id;
                this.delivery.cdek_id = suggestion.data.cdek_id ||
                    this.delivery.cdek_id;
                this.delivery.dpd_id = suggestion.data.dpd_id ||
                    this.delivery.dpd_id;
            });
        event.preventDefault();
    },

    initSuggestions(serviceUrl, token) {
        const el = $(this.$refs.input);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 7,
            onSelect: this.onSelect,
            onSelectNothing: this.onSelectNothing,
        };
        el.suggestions(params);
    },

    onSelect(suggestion) {
        this.value = suggestion.value;
        this.address = suggestion.data;
        this.delivery = null;
        this.usageTimes++;
        Analytics.reachGoal(this.goalName);
    },

    onSelectNothing() {
        this.address = null;
        this.delivery = null;
    },

    clear() {
        this.value = "";
        this.address = null;
        this.delivery = null;
    },

    copyLink(event) {
        const addressId = this.address.fias_id || this.address.geoname_id;
        const url = objectLink.buildUrl("address", addressId);
        objectLink.copy(url);
        objectLink.showCopied(this);
        event.preventDefault();
    },
};

const watch = {
    enableForeign(isEnabled) {
        const country = isEnabled ? "*" : "Россия";
        this.suggestions.setOptions({ constraints: { locations: { country } } });
    },
    englishLanguage(isEnabled) {
        const language = isEnabled ? "en" : "ru";
        this.suggestions.setOptions({
            hint: HINT[language],
            params: { language },
        });
    },
    municipalDivision(isEnabled) {
        const division = isEnabled ? "municipal" : "administrative";
        this.suggestions.setOptions({ params: { division } });
    },
};

function buildConfig(serviceUrl, token, goalName) {
    return {
        data() {
            return {
                ...STATE,
                goalName,
            };
        },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
            document.addEventListener("address-change", e => {
                this.clear();
                this.value = e.detail.value;
            });
        },
        computed: properies,
        components: { demoFormPopup },
        methods,
        watch,
    };
}

export default function Suggestions(serviceUrl, token, goalName) {
    const addressConfig = buildConfig(serviceUrl, token, goalName);

    createComponent(addressConfig, "#address-vue-app");
}
